import React from 'react';
import styles from './infohubContainer.module.scss';
export default function index({children, extraClass}) {
    return (
        <div className={`${styles.container} ${styles[extraClass]}`}>{children}</div>
    )
}
